import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    redirect: '/SubsTance',
    children: [
      {
        path: '/SubsTance',
        name: 'SubsTance',
        component: () => import('../components/SubsTance.vue')
      },
      {
        path: '/TabnavigationBar',
        name: 'TabnavigationBar',
        component: () => import('../components/TabnavigationBar.vue'),
      },
      {
        path: '/PjanNavigationbar',
        name: 'PjanNavigationbar',
        component: () => import('../components/navigationbar/PjanNavigationbar.vue'),
        meta: { title: '判决案例', keepAlive: true },
        children: [
          {
            path: '/highcourt',
            name: 'highcourt',
            component: () => import('../views/article/judgment/highcourt.vue'),
          }
        ]
      },
      {
        path: '/JfznNavigationbar',
        name: 'JfznNavigationbar',
        component: () => import('../components/navigationbar/JfznNavigationbar.vue'),
        meta: { title: '解纷指南', keepAlive: true },
        children: [
          {
            path: '/mediationlaw',
            name: 'mediationlaw',
            component: () => import('../views/article/resolving/mediationlaw.vue')
          },
        ]
      },
      {
        path: '/SfwznNavigationbar',
        name: 'SfwznNavigationbar',
        component: () => import('../components/navigationbar/SfwznNavigationbar.vue'),
        meta: { title: '诉讼服务指南', keepAlive: true },
        children: [
          {
            path: '/xzproceeding',
            name: 'xzproceeding',
            component: () => import('../views/article/proceeding/xzproceeding.vue'),
          },
          {
            path: '/sdproceeding',
            name: 'sdproceeding',
            component: () => import('../views/article/proceeding/sdproceeding.vue'),
          },
          {
            path: '/csproceeding',
            name: 'csproceeding',
            component: () => import('../views/article/proceeding/csproceeding.vue'),
          },
        ]
      },
      {
        path: '/TjymdNavigationbar',
        name: 'TjymdNavigationbar',
        component: () => import('../components/navigationbar/TjymdNavigationbar.vue'),
        meta: { title: '调解员名单', keepAlive: true }
      },
      {
        path: '/TjznNavigationbar',
        name: 'TjznNavigationbar',
        component: () => import('../components/navigationbar/TjznNavigationbar.vue'),
        meta: { title: '调解指南', keepAlive: true },
        children: [
          {
            path: '/newlpr',
            name: 'newlpr',
            component: () => import('../views/article/guide/newlpr.vue'),
          },
          {
            path: '/resolution',
            name: 'resolution',
            component: () => import('../views/article/guide/resolution.vue'),
          }
        ]
      },
      {
        path: '/XwdtNavigationbar',
        name: 'XwdtNavigationbar',
        component: () => import('../components/navigationbar/XwdtNavigationbar.vue'),
        meta: { title: '新闻动态', keepAlive: true },
        children: [
          {
            path: '/newxf',
            name: 'newxf',
            component: () => import('../views/article/news/newxf.vue'),
          },
          {
            path: '/newsx',
            name: 'newsx',
            component: () => import('../views/article/news/newsx.vue'),
          },
          {
            path: '/newyh',
            name: 'newyh',
            component: () => import('../views/article/news/newyh.vue'),
          },
          {
            path: '/newzy',
            name: 'newzy',
            component: () => import('../views/article/news/newzy.vue'),
          },
          {
            path: '/newfy',
            name: 'newfy',
            component: () => import('../views/article/news/newfy.vue'),
          },
          {
            path: '/newtj',
            name: 'newtj',
            component: () => import('../views/article/news/newtj.vue'),
          },
          {
            path: '/newwd',
            name: 'newwd',
            component: () => import('../views/article/news/newwd.vue'),
          },
          {
            path: '/newyq',
            name: 'newyq',
            component: () => import('../views/article/news/newyq.vue'),
          },
          {
            path: '/newdy',
            name: 'newdy',
            component: () => import('../views/article/news/newdy.vue'),
          },
          {
            path: '/newrm',
            name: 'newrm',
            component: () => import('../views/article/news/newrm.vue'),
          },
          {
            path: '/newkj2',
            name: 'newkj2',
            component: () => import('../views/article/news/newkj2.vue'),
          },
          {
            path: '/newkj1',
            name: 'newkj1',
            component: () => import('../views/article/news/newkj1.vue'),
          },
          {
            path: '/newzh',
            name: 'newzh',
            component: () => import('../views/article/news/newzh.vue'),
          },
          {
            path: '/newbh',
            name: 'newbh',
            component: () => import('../views/article/news/newbh.vue'),
          },
          {
            path: '/newbj',
            name: 'newbj',
            component: () => import('../views/article/news/newbj.vue'),
          },
          {
            path: '/newtz',
            name: 'newtz',
            component: () => import('../views/article/news/newtz.vue'),
          },
          {
            path: '/newbg',
            name: 'newbg',
            component: () => import('../views/article/news/newbg.vue'),
          },
          {
            path: '/newbm',
            name: 'newbm',
            component: () => import('../views/article/news/newbm.vue'),
          },
          {
            path: '/newxp',
            name: 'newxp',
            component: () => import('../views/article/news/newxp.vue'),
          },
        ]
      },
    ]
  },
  {
    path: '/cn',
    name: 'cn',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/xy',
    name: 'xy',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/zh',
    name: 'zh',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/sx',
    name: 'sx',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/jm',
    name: 'jm',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/hz',
    name: 'hz',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/zq',
    name: 'zq',
    component: () => import('../views/HomeView.vue')
  },
]


const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
